export enum PaymentStatusTypes {
  None = 0,
  Unpaid = 1,
  Paid = 2,
  AutoUnpaid = 11,
  AutoPaid = 12,
}

export function getPaymentStatusTypeName(value: PaymentStatusTypes): string {
  switch (value) {
    case PaymentStatusTypes.None: return '未指定';
    case PaymentStatusTypes.Unpaid: return '未納';
    case PaymentStatusTypes.Paid: return '既納';
    case PaymentStatusTypes.AutoUnpaid: return '未納(自動)';
    case PaymentStatusTypes.AutoPaid: return '既納(自動)';
  }
}
